import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { DonationPage } from './pages/DonationPage';
import { DashboardPage } from './pages/DashboardPage';
import { AuthProvider } from './contexts/AuthContext';
export function App() {
  useEffect(() => {
    document.title = 'MU Vanguard S6';
  }, []);
  return <AuthProvider data-id="element-0">
      <Router data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<LandingPage data-id="element-4" />} data-id="element-3" />
          <Route path="/donation" element={<DonationPage data-id="element-6" />} data-id="element-5" />
          <Route path="/dashboard" element={<DashboardPage data-id="element-8" />} data-id="element-7" />
        </Routes>
      </Router>
    </AuthProvider>;
}